var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"secondary-button",style:(_vm.buttonStyle),attrs:{"to":_vm.to,"type":_vm.type,"href":_vm.href,"disabled":_vm.disabled,"dark":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }